module.exports = __webpack_public_path__ + "img/contents_flower@2x.e41892c3.png";